import { render } from "./EncuestaView.vue?vue&type=template&id=1fbd8ccb&scoped=true"
import script from "./EncuestaView.vue?vue&type=script&lang=js"
export * from "./EncuestaView.vue?vue&type=script&lang=js"

import "./EncuestaView.vue?vue&type=style&index=0&id=1fbd8ccb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fbd8ccb"]])

export default __exports__